import { render, staticRenderFns } from "./BarberModal.vue?vue&type=template&id=a65d312e&scoped=true&"
import script from "./BarberModal.vue?vue&type=script&lang=js&"
export * from "./BarberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65d312e",
  null
  
)

export default component.exports